import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-review-color",
  "use": "icon-review-color-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-review-color\">\n<rect width=\"40\" height=\"40\" rx=\"20\" fill=\"#189EFF\" />\n<rect x=\"13\" y=\"11\" width=\"13.3846\" height=\"18\" rx=\"1\" stroke=\"white\" stroke-width=\"2\" />\n<rect x=\"15.0769\" y=\"16.9231\" width=\"9.23077\" height=\"1.15385\" rx=\"0.576923\" fill=\"white\" />\n<rect x=\"15.0769\" y=\"20.7693\" width=\"9.23077\" height=\"1.15385\" rx=\"0.576923\" fill=\"white\" />\n<rect opacity=\"0.6\" x=\"15.0769\" y=\"24.6155\" width=\"9.23077\" height=\"1.15385\" rx=\"0.576923\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/review-color.svg
// module id = Ka4j
// module chunks = 262